export default "__VITE_ASSET__CM2wNX7P__"